import { render } from "./WeeklyReport.vue?vue&type=template&id=3c8b126a&scoped=true"
import script from "./WeeklyReport.vue?vue&type=script&lang=js"
export * from "./WeeklyReport.vue?vue&type=script&lang=js"

import "./WeeklyReport.vue?vue&type=style&index=0&id=3c8b126a&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8b126a"]])

export default __exports__